import type { ClinicSubscriptionResponse } from "@/domains/multi/clinicTypes";
import type { BillingSubscriptionSummary } from "@/domains/subscription/billingHelpers";

export function mapClinicSubscriptionToBillingSummary(
    response: ClinicSubscriptionResponse,
    user?: { subscriptionPlan?: string | null; subscriptionEndsAt?: string | null },
): BillingSubscriptionSummary | null {
    const sub = response.subscription;
    if (!sub?.status) {
        return null;
    }

    const status = sub.status;
    if (status === "none" || status === "expired" || status === "pending") {
        return null;
    }

    const planSlug = sub.planSlug ?? user?.subscriptionPlan ?? "Basico";
    const manageable = status === "active" || status === "cancel_at_period_end";

    return {
        subscriptionPlan: planSlug,
        currentPlanId: planSlug,
        planName: planSlug,
        status,
        paymentMethod: sub.paymentMethod ?? null,
        periodEndDate: sub.currentPeriodEnd ?? null,
        nextChargeDate: sub.nextChargeDueDate ?? sub.currentPeriodEnd ?? null,
        subscriptionEndsAt: sub.currentPeriodEnd ?? user?.subscriptionEndsAt ?? null,
        subscriptionCancelledAt: status === "cancel_at_period_end" ? sub.currentPeriodEnd ?? undefined : undefined,
        canChangePlan: manageable,
        canChangePaymentMethod: status === "active" && Boolean(sub.paymentMethod),
        billingProvider: response.billingProvider ?? null,
        devFakeBillingAvailable: response.devFakeCheckoutAvailable,
    };
}
